export async function searchCep(cep) {
  cep = cep.replace(/\D/g, '');
  return fetch(`https://viacep.com.br/ws/${cep}/json/`).then((res) => res.json());
}
